import React from "react";
var __jsx = React.createElement;
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var PostsContainer = function PostsContainer(_ref) {
  var posts = _ref.posts;
  var thePostsFiltered = posts.filter(function (post) {
    return !post.isEligibilityCard;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-5 flex-nowrap overflow-auto px-5 snap-x snap-mandatory mt-8 lg:grid lg:grid-cols-[repeat(auto-fill,minmax(273px,1fr))] lg:gap-5 list-none lg:pb-0 lg:mt-0 lg:px-0"
  }, thePostsFiltered.map(function (post, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "md:w-full h-full w-[300px] flex-shrink-0"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      rank: idx + 1
    })));
  })));
};
export default PostsContainer;